/* src/app/dashboard/leaderboard/org-leaderboard/org-leaderboard.component.scss */
.lb-container {
  display: flex;
  padding-top: 10px;
  flex-direction: column;
}
.lb-row {
  display: flex;
  flex: 1 1 auto;
  padding: 5px 10px 5px 10px;
}
.lb-rank {
  flex: 0 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 1.2rem;
  min-width: 80px;
  margin-right: 10px;
}
.lb-rank-trophy {
  width: 40px;
  text-align: left;
}
.lb-rank-number {
  text-align: left;
  min-width: 30px;
}
.lb-center {
  flex: 2 1 auto;
  justify-content: flex-start;
}
.lb-center-top {
  text-align: left;
  font-size: 1.2rem;
}
.lb-center-bottom {
  color: #3C3C3C;
  text-align: left;
  font-weight: normal;
}
.lb-score {
  flex: 1 1 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 5px;
  font-size: 1.2rem;
}
.lb-loading {
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  padding-top: 20px;
}
.first_place {
  color: #F1C40F;
  animation: growShakeShrink 2s ease-in-out forwards;
  display: inline-block;
}
.second_place {
  color: #B3B6B7;
  animation: growShakeShrink 2s ease-in-out forwards;
  display: inline-block;
}
.third_place {
  color: #CD7F32;
  animation: growShakeShrink 2s ease-in-out forwards;
  display: inline-block;
}
.green_border {
  border-radius: 10px;
  border-style: solid;
  border-width: 2px;
  border-color: var(--primary-color);
  background-color: #d4eef0;
}
@keyframes growShakeShrink {
  0%, 100% {
    transform: scale(1);
  }
  25% {
    transform: scale(2);
  }
  30%, 40%, 50%, 60%, 70% {
    transform: scale(2) rotate(20deg);
  }
  35%, 45%, 55%, 65% {
    transform: scale(2) rotate(-20deg);
  }
  75% {
    transform: scale(2) rotate(0deg);
  }
  90% {
    transform: scale(1);
  }
}
/*# sourceMappingURL=org-leaderboard.component.css.map */
